import React from 'react';
import LiveOrdersDashboard from './LiveOrdersDashboard';

const LiveOrdersDashboardPage = () => {
  return <LiveOrdersDashboard />;
};

export default LiveOrdersDashboardPage;
